import { isEmpty } from '../assertion'

export const reallyTruthy = (value: any): boolean => {
  return !(
    !value ||
    value === 'false' ||
    value === '0' ||
    isEmpty(value) ||
    value === 'undefined'
  )
}
